import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {POST_NON_NATIONAL_EXAM_WITHDRAWAL_DRAFT_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface WithdrawalDraftResponse {
  uuid: string;
}

export interface WithdrawalDraftRequest {
  uuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: WithdrawalDraftResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateNonNationalExamWithdrawalDraft = ({onSuccess, onError}: Input = {}) => {
  const postCreateNonNationalExamWithdrawalDraft = async (reqBody: WithdrawalDraftRequest) => {
    const res = await axiosClient.post<WithdrawalDraftResponse>(
        POST_NON_NATIONAL_EXAM_WITHDRAWAL_DRAFT_URL,
        reqBody
    );
    return res.data;
  };

  return useCustomMutation(postCreateNonNationalExamWithdrawalDraft, {
    onSuccess,
    onError,
  });
};
